/**
 * Hand-authored token values that Highcharts reads raw (it can't resolve CSS vars).
 *
 * Formerly `@morpho-org/ui-v6/styles/tailwind.generated.v5` — an auto-generated file
 * whose generator (`generateThemeConstants.ts`) was already deleted. The colour subset
 * lives in the charts' `chartColors.ts`; the rest of the legacy V5 theme object was
 * retired with the V5 ui-kit, leaving only the spacing / shadow / gradient values
 * below that `chartTheme.ts` and `ChartStatusNoData` still consume.
 */

// Spacing values
export const spacing = {
  '2xs': '4px',
  xs: '8px',
  s: '12px',
  m: '20px',
  l: '32px',
  xl: '80px'
} as const

// Box shadow values
export const boxShadow = {
  dp2: '0px -1px 2px 0px rgba(6, 9, 11, 0.04), 0px 0px 2px 0px rgba(0, 0, 0, 0.08), 0px 1px 1px 0px rgba(0, 0, 0, 0.1)',
  dp4: '0px 3px 4px 0px rgba(0, 0, 0, 0.09)',
  dp8: '0px 1px 10px 0px rgba(0, 0, 0, 0.04), 0px 8px 12px 0px rgba(6, 9, 11, 0.05), 0px 4px 8px 0px rgba(0, 0, 0, 0.07)',
  dp12: '0px 1px 20px 0px rgba(0, 0, 0, 0.04), 0px 6px 12px 0px rgba(0, 0, 0, 0.07), 0px 12px 16px 0px rgba(6, 9, 11, 0.06), 0px 18px 24px 0px rgba(0, 0, 0, 0.08)'
} as const

// Drop shadow values (for filter property)
export const dropShadow = {
  dp2: 'drop-shadow(0px -1px 2px rgba(6, 9, 11, 0.04)) drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.08)) drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.1))',
  dp4: 'drop-shadow(0px 3px 4px rgba(0, 0, 0, 0.09))',
  dp8: 'drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 12px rgba(6, 9, 11, 0.05)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.07))',
  dp12: 'drop-shadow(0px 1px 20px rgba(0, 0, 0, 0.04)) drop-shadow(0px 6px 12px rgba(0, 0, 0, 0.07)) drop-shadow(0px 12px 16px rgba(6, 9, 11, 0.06)) drop-shadow(0px 18px 24px rgba(0, 0, 0, 0.08))'
} as const

// Gradient values — Highcharts reads these raw (it can't resolve CSS vars).
// The `earth` gradient moved to @repo/tailwind-config (`bg-earth`); the planet
// palette + scroll-indicator/page-background semantics were dead and removed.
export const gradients = {
  'chart-blue-area': 'linear-gradient(to left, #2470ff, #5792ff)',
  'chart-blue-area-transparent': 'linear-gradient(#2470ff33 0%, transparent 80% )'
} as const
